import { Routes } from '@angular/router';
import { BusinessRegComponent } from './business-reg/business-reg.component';
import { SilentRedirectComponent } from './silent-redirect/silent-redirect.component';

export const routes: Routes = [
    // { path: '', redirectTo: 'business-reg', pathMatch: 'full' },
    { path: '', component: SilentRedirectComponent },
    {
        path: 'business-reg'
        //, component: BusinessRegComponent,
        , loadChildren: () => import('./business-reg/business-reg.module').then(m => m.BusinessRegModule)
    }
];
